import { Iconsvg, InputField, SelectField, TextareaField, Tooltip, TooltipBody } from '@wk/components-react16';
import GaugeChart from "react-gauge-chart";
import { Toast } from '../../services';
import { useEffect, useRef, useState } from 'react';
import TaxonomyTags from '../prompt/model/TaxonomyTags';
import { encode } from 'gpt-tokenizer';

const EditSmartPrompt = ({ data }: any) => {
    const { prompt, setPrompt, handlePromptScore, isScoreShow, promptTypeList, promptCategoryScore, taxonomyTree, setTaxonomyTree, validateTaxonomy } = data;

    const [isShowTaxonomyTree, setIsShowTaxonomyTree] = useState(false);
        const treeRef = useRef<HTMLDivElement>(null);

        const handleInputChange = (event: any) => {
            const { name, value } = event.target;
            if(name === 'type') {
                const promptType = promptTypeList.find((item: any) => item.id === parseInt(value));
                setPrompt({
                    ...prompt,
                    promptType,
                });
            } else {
                setPrompt({
                    ...prompt,
                    [name]: value,
                });
            }
        };

        const handleRemoveTags = (event: any, node: any) => {
            event.stopPropagation();
            const st = prompt?.tags?.filter((item: any) => item.id != node.id);
            setPrompt({ ...prompt, tags: st });
            const updatedTree = uncheckNodeById(taxonomyTree, node.id);
            setTaxonomyTree([...updatedTree]);
            validateTaxonomy(updatedTree);
        }

        const uncheckNodeById = (tree: any, nodeId: number) =>{
            return tree.map((node: any) => {
                if (node.id === nodeId) {
                    return { ...node, isChecked: false };
                }

                if (node.children && node.children.length > 0) {
                    return {
                        ...node,
                        children: uncheckNodeById(node.children, nodeId)
                    };
                }

                return node;
            });
        }

        const showHideTaxonomyTree = (status: boolean) => {
            if (!prompt.promptType || !prompt.promptType.code || !prompt.promptType.code.trim()) {
                Toast('Please select prompt type', "error");
                return;
            }
            setIsShowTaxonomyTree(status);
            if (!status) {
                validateTaxonomy(taxonomyTree);
            }
        };

        useEffect(() => {
            if (isShowTaxonomyTree) {
                const handleClickOutside = (event: any) => {
                    if (treeRef.current && !treeRef.current.contains(event.target)) {
                        setIsShowTaxonomyTree(false);
                        validateTaxonomy(taxonomyTree);
                    }
                };

                document.addEventListener('click', handleClickOutside);

                return () => {
                    document.removeEventListener('click', handleClickOutside);
                };
            }
        }, [taxonomyTree, isShowTaxonomyTree]);

    return (
        <div className='position-relative'>
            {isScoreShow ? <div className="position-absolute end-0 text-right cursor-pointer" style={{ top: '-7px' }} onClick={() => handlePromptScore(false)} aria-disabled={!prompt.promptType || !prompt.name || !prompt.text}>
                <span className='text-body-secondary d-inline-block'>Score</span> <GaugeChart style={{ display: 'inline-block',width: '50px' }}
                    id="gauge-chart3"
                    nrOfLevels={3}
                    colors={["red", "orange", "green"]}
                    arcWidth={0.3}
                    arcsLength={[0.3, 0.5, 0.2]}
                    percent={prompt.score && promptCategoryScore.length > 0 ? (prompt.score / (promptCategoryScore.length * 5)) : 0}
                    textColor={'black'}
                    hideText={true}
                />
            </div> : null}
            <SelectField label="Prompt Type" labelFor="select-id-1-2" indicator="required">
                <select id="select-id-1-2" name="type"
                    onChange={(event: any) => handleInputChange(event)}
                    value={prompt.promptType?.id || ''}>
                    <option value="" disabled>-- Select Prompt Type --</option>
                    {promptTypeList?.map((item: any, i: number) => <option value={item.id} key={i}>{item.name}</option>)}
                </select>
            </SelectField>
            <div className="cg-field-header" style={{ fontSize: '0.875rem' }}>
                <label className="cg-field-label">Tag Taxonomy
                    <div className="cg-field-required-indicator"><span aria-hidden="true">*</span></div>
                </label>
            </div>
            <div className="custom-suggestion-list custom-input-readonly mb-20 position-relative" id="taxonomy-tree" ref={treeRef}>
                <div className='multiSelectedItem' onClick={(event: any) => showHideTaxonomyTree(!isShowTaxonomyTree)}>
                    {prompt.tags?.length > 0 ? prompt.tags.map((item: any, index: number) => (
                        <span className="mr-5 badge text-bg-light align-middle" key={index}>
                            <span className='align-middle wk-primary-blue type'>{item.name}</span>
                            <span className='ml-5 cursor-pointer' onClick={(event: any) => handleRemoveTags(event, item)}>
                                <Iconsvg name="close" color={'#E5202E'} size={12}></Iconsvg>
                            </span>
                        </span>
                    )) : null}
                    <div className="d-inline-block pe-none align-middle">
                        <span className='d-inline-block'>({prompt.tags?.length})</span>{' '} Taxonomy Selected
                    </div>
                    <div className="custom-down-arrow" onClick={(event: any) => showHideTaxonomyTree(!isShowTaxonomyTree)}>
                        <Iconsvg name="chevron-down" size={16}></Iconsvg>
                    </div>
                </div>
                {isShowTaxonomyTree && <TaxonomyTags data={{ prompt, setPrompt, taxonomyTree, setTaxonomyTree }} />}
            </div>
            <InputField label="Prompt Name" labelFor="input-id-1-1" indicator="required">
                <input
                    type="text" id="input-id-1-1" name="name"
                    placeholder="Prompt Name"
                    onChange={(event: any) => handleInputChange(event)}
                    value={prompt.name} autoComplete="off"
                />
            </InputField>
            <div className="position-relative">
                <div style={{ fontSize: '12px', color: encode(prompt.text || '').length > 1200 ? '#E5202E' : '#777' }} className='position-absolute top-0 end-0'>{encode(prompt.text || '').length}/ 1200 tokens 
                    <span className="ml-10" id='info-icon'><Iconsvg name="info" size={16} ></Iconsvg></span>
                    <Tooltip
                        targetSelector="#info-icon"
                        identifier="tooltip-top"
                        position="top"
                        >
                        <TooltipBody slot="tooltipBody">Staying within ~1200 tokens helps the AI follow instructions more accurately. This is only a guideline; your prompt will still work beyond this.</TooltipBody>
                    </Tooltip>
                </div>
                <TextareaField label="Generated Prompt Instructions" labelFor="textarea-id-1" indicator="required">
                    <textarea style={{ height: '10rem' }}
                        id="textarea-id-1" name="text"
                        placeholder="Prompt Instructions"
                        onChange={(event: any) => handleInputChange(event)}
                        value={prompt.text}
                    ></textarea>
                </TextareaField>
            </div>
        </div>
    );
};

export default EditSmartPrompt;